export const SINGLE_MONTH_ID = "1m";
export const CAMPAIGNS_MONTHS_RANGE_INTERVALS = [1, 3, 6, 12];
export const CAMPAIGNS_DURATION_ONE_WEEK_ID = "6d";
export const CAMPAIGNS_ALL_TIME_ID = "all";
export const FIRST_DAY_CREATION_ID = "0d";
export const MAX_ALLOWED_DURATION_DEMO_CAMPAIGN = "3m";
